// eslint-disable-next-line import/prefer-default-export
export var presetSizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 48,
  xl: 96
};